export default function createMenuItemFromResource(data) {
  if (!data) return null;

  return {
    actions: {
      editable: !!data?.actions?.editable,
      archivable: !!data?.actions?.archivable,
      restore: !!data?.actions?.restore,
    },
    icon: data.icon ?? null,
    id: data.menu_item_id ?? null,
    mainId: data.id ?? null,
    menuItemId: data.menu_item_id ?? null,
    isAllowedForAuthorized: data.is_allowed_for_authorized ?? null,
    isAllowedForGuest: data.is_allowed_for_guest ?? null,
    isArchived: data.is_archived ?? null,
    isEnabled: data.is_enabled ?? null,
    name: data.name ?? '',
    status: data.status ?? null,
    panelId: data.panel_id ?? null,
    parent: data.parent ?? null,
    parentId: data.parent?.id ?? null,
    sorting: data.sorting ?? null,
    translations: data.translations ?? {},
    url: data.url ?? '',
  };
}
